import React, { useState } from "react";
import TextField from "@mui/material/TextField";

import { sendPushNotification, updateFees, updateMetaData } from "../data/API";
import {
  Typography,
  Grid,
  Paper,
  Card,
  CardMedia,
  Button,
  Checkbox,
  Box,
} from "@mui/material";

export default function BasicSettings({ feesAndTaxes, metaData, setLoading, setWarning }) {
  var [copyData, setData] = useState(feesAndTaxes);




  var [copyMetaData, setMetaData] = useState(metaData);


  function getMeta(key) {
   

    var rValue = "Invalid Key";
    copyMetaData?.forEach(function (element) {
      if (element['NAME'] === key) {
        rValue = element['DATA'];
      }

    });
    return rValue;
  }

  function updateCopiedMeta(key, data) {
    var index = -1;
    copyMetaData?.forEach(function (element, i) {
      if (element['NAME'] === key) {
        index = i;
      }

    });
    if (index != -1) {
      var record = copyMetaData[index];
      record["DATA"] = data;
      copyMetaData[index] = record;
      setMetaData(copyMetaData);

  
    }



  }

  function updateMeta(data) {
    //make network call
    setLoading(true);
    setWarning(false);
    console.log("called");
    console.log(data);
    updateMetaData(data, (err, d) => {
      console.log(err,d)
      if (err) {
        setLoading(false);
        setWarning(true);
      } else {
        setLoading(false);
        setWarning(false);
        setMetaData(d);
      }
    })

  }





  function update(data) {


    //make network call
    setLoading(true);
    setWarning(false);
    updateFees(data, (err, d) => {
      if (err) {
        setLoading(false);
        setWarning(true);
      } else {
        setLoading(false);
        setWarning(false);
        setData(d);
      }
    })

  }

  var [message, setMessage] = useState('');
  var [messageTtl, setMessageTtl] = useState('');

  function sendNotification(topic) {
    setLoading(true);
    setWarning(false);
    sendPushNotification({ "msg": message, "title": messageTtl, 'topic': topic }, (data, d) => {

      setLoading(false);
      setWarning(false);


    });
  }

  return (
    <div>
      <div className="pt-4">

        <Typography className="pb-4" variant="subtitle2">Send Push Notification</Typography>
        <TextField

          sx={{ width: 300 }}
          inputMode="multiline"
          label={"Notification Title"}
          placeholder="Type Value"
          defaultValue={messageTtl}

          color="success"
          onChange={(e) => {
            setMessageTtl(e.target.value);
          }} />

        <Button
          onClick={function () {
            sendNotification("new");
          }}
          variant="contained"
          color="primary"

          sx={{ mx: 1, height: 55 }}
        >
          SEND TO UNREGISTERED USERS/KITCHENS
        </Button>
        <p className="py-1"></p>

        <TextField

          sx={{ width: 500 }}
          inputMode="multiline"
          label={"Notification Message"}
          placeholder="Type Value"
          defaultValue={message}

          color="success"
          onChange={(e) => {
            setMessage(e.target.value);
          }} />

        <Button
          onClick={function () {
            sendNotification("kitchen");
          }}
          variant="contained"
          color="error"

          sx={{ mx: 1, height: 55 }}
        >
          SEND TO KITCHENS
        </Button>

        <Button
          onClick={() => {
            sendNotification("user");
          }}
          variant="contained"
          color="warning"

          sx={{ mx: 1, height: 55 }}
        >
          SEND TO REGISTERED USERS
        </Button>
        <p className="py-3" />

        <Typography className="pb-4" variant="subtitle2">Fees And Taxes</Typography>





        <div className="flex gap-2">
          {copyData?.map((element, i) => {
            return (
              <div>
                <TextField
                  label={element.name}
                  placeholder="Type Value"
                  defaultValue={element.value}
                  onChange={(e) => {
                    copyData[i].value = e.target.value;
                  }}
                />

              </div>
            );
          })}
        </div>
        <Button
          onClick={() => update(copyData)}
          variant="contained"
          color="success"
          sx={{ mt: 2 }}
        >
          Save
        </Button>
      </div>

      <Typography className="py-4" variant="subtitle2">BillPlz Settings </Typography>
      <TextField
        style={{ width: 400 }}

        inputMode="secret"
        security="true"
        
        label={"Secret Key (Test=4c55fe0e-1eb4-4251-9504-0bd0e34976f0)"}
        placeholder="Type Value"
        defaultValue={getMeta('billplz_key')}
        onChange={(e) => {
         
          updateCopiedMeta('billplz_key', e.target.value);

        }} />

      <span className="px-2" />



      <TextField
        label={"Collection Id (Test=rhlhqtop)"}
        placeholder="Type Value"
        defaultValue={getMeta('billplz_collection_id')}

        onChange={(e) => {
          updateCopiedMeta('billplz_collection_id', e.target.value);

        }} />



      <span className="px-2" />

      <TextField
        label={"Bank Code"}
        placeholder="Type Value"
        defaultValue={getMeta('bank_code')}

        onChange={(e) => {
          updateCopiedMeta('bank_code', e.target.value);

        }} />
      <p className="py-2" />

      <TextField
       
        style={{ width: 500 ,marginBottom:20}}
        label={"API URL (Test=https://www.billplz-sandbox.com/api/v3/bills)"}
        placeholder="Type Value"
        defaultValue={getMeta('billplz_bill_url')}

        color="error"
        onChange={(e) => {

          updateCopiedMeta('billplz_bill_url', e.target.value);

        }} />

      <Button
        onClick={() => {

          updateMeta(copyMetaData);

        }}
        variant="contained"
        color="success"
        sx={{ mt: 1, mx: 4 }}
      >
        SAVE BILLPLZ SETTINGS
      </Button>

    </div>
  );
}
